module.exports = __webpack_public_path__ + "img/04.158708f2.jpg";